module.exports = __webpack_public_path__ + "img/barriereneige.440ab1d0.jpg";